module.exports = __webpack_public_path__ + "img/dong.e06ba9fd.png";